// @ts-strict-ignore
import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  Input, NgZone,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import * as urltemplate from 'url-template';
import { AppConstants, LMConditionUtilService, LMTransformOptions } from '@utils/index';
import { ChangeDetectorRef, QueryList, ViewChildren } from '@angular/core';
import {
  LMBusyIndicatorService,
  LMContextService, LMErrorUtilService,
  LMFormatUtilService,
  LMLoggerService,
  LMUrlUtilService
} from '@services/index';
import {
  LMListEventService,
  LMListGridPagingService,
  LMListSpecUtilService,
  LMListUtilService
} from './services/';
import { LMChartBase } from '@chart/lm-chart-base';
import { Observable, Subject, Subscription } from 'rxjs';
import { LMListChartSelectorsComponent } from './lm-list-chart-selectors.component';
import { LMFormatterService } from './formatters';
import { SohoBusyIndicatorDirective } from 'ids-enterprise-ng';
import { LMListContentBaseComponent } from './lm-list-content-base.component';
import { LMThemeService } from '@banner/lm-theme.service';
import { LMDataGridBaseComponent } from '@app/components';
import { LMListChartAggregationComponent } from '@list/lm-list-chart-aggregation';

@Component({
  selector: 'lm-list-chart',
  templateUrl: './lm-list-chart.component.html',
  styleUrls: [ 'lm-list-chart.component.scss' ]
})
export class LMListChartComponent extends LMListContentBaseComponent implements LMListContentInterface, OnInit, OnDestroy, AfterViewChecked, AfterViewInit {

  @ViewChildren('LMChartComponent') lmChartComponents: QueryList<LMChartBase>;
  @ViewChild(SohoBusyIndicatorDirective) sohoBusyIndicator: SohoBusyIndicatorDirective;
  @ViewChild('LMListChartSelectors') lmListChartSelectors: LMListChartSelectorsComponent;
  @ViewChild('LMListChartAggregation') lmListChartAggregation: LMListContentInterface;

  @HostBinding('class.chart-container') get hostScrollable() {
    return true;
  }

  @HostBinding('class.card') showAsCard = false;
  @HostBinding('class.lm-dashboard-chart') get isDashboardChart() {
    return this.isDashBoardContent;
  }

  @Input() set chartName(chartName: string) {
    // Safety check
    if (!chartName || this._chartName === chartName) {
      return;
    }

    this._chartName = chartName;
    this._chartNameChanged = true;

    this.setChartType();

    if (this.getType() === 'aggregation'
      && this.lmListChartAggregation
      && this.lmListChartAggregation.chartName !== chartName) {
      this.lmListChartAggregation.chartName = chartName;
    }
  }

  /**
   * ListState for a list and all it's contents
   */
  @Input() listState: LMListState;

  @Input() listUrlInfo: LMListUrlInfo;

  // error TS2610: 'listSpec' is defined as an accessor in class 'LMListContentBaseComponent'
  // @Input() listSpec: LMListSpec;

  // error TS2610: 'disabled' is defined as an accessor in class 'LMListContentBaseComponent
  // @Input() disabled: boolean;

  @Input() set periodIndex(periodIndex: number) {
    this._periodIndex = periodIndex;
    this._periodIndexChanged = true;
  }

  get periodIndex(): number {
    return this._periodIndex;
  }

  @Input() isDashBoardContent: boolean;

  public lmChartComponent: LMChartBase;
  public type: string;
  public chartElementTitle: string;

  public _chartName: string;
  private _chartNameChanged = false;
  private _fromDataViewChanged = false;
  private _periodIndexChanged = false;
  private implementsCancelablePaging = false;
  private cancelPagingNotifier$: Subject<boolean>;
  private _filterCriteriaChanged = false;

  /**
   * Internal member variable, Use listSpec getter when referencing this object.
   */
  private _labels: any = {
    contentsTop: 'value',
    formatterTop: '$,.2f',
    hideLabels: false
  };

  private basicData: SohoDataSet;
  private _basicData: SohoDataSet;
  public xAxisFields = [];
  public yAxisFields = [];
  public xAxisId: string;
  public yAxisId: string;
  public selectedXAxis = 0;
  public selectedYAxis = 0;
  public hasChartData = false;
  private _isColumnarView: boolean;

  get isColumnarView() {
    if (this._isColumnarView === undefined) {
      this._isColumnarView = this.lmListSpecUtilService.isColumnarView(this.listSpec);
    }

    return this._isColumnarView;
  }

  public lines = {};
  public tooltip = { show: 'label (value)', formatter: '.0f' };
  public showAxisLabels = false;

  private statesArray = [];
  private _periodIndex = 0;
  private isPercentPie = false;

  get uiLoadingIndicatorTimeout(): number {
    return this.lmContextService.uiLoadingIndicatorTimeout;
  }

  constructor(
    public elementRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private ngZone: NgZone,
    private lmBusyIndicatorService: LMBusyIndicatorService,
    protected lmContextService: LMContextService,
    protected lmConditionUtilService: LMConditionUtilService,
    protected lmFormatUtilService: LMFormatUtilService,
    private lmFormatterService: LMFormatterService,
    private lmListEventService: LMListEventService,
    private lmListGridPagingService: LMListGridPagingService,
    private lmListSpecUtilService: LMListSpecUtilService,
    protected lmListUtilService: LMListUtilService,
    protected lmLoggerService: LMLoggerService,
    protected lmThemeService: LMThemeService,
    private lmUrlUtilService: LMUrlUtilService,
    protected lmErrorUtilService: LMErrorUtilService
  ) {
    super(lmLoggerService, lmThemeService, lmFormatUtilService, lmListUtilService, lmConditionUtilService);
  }

  ngOnInit() {
    this.setChartType();
    if (this.getType() === 'aggregation') {
      return;
    }
    this.implementsCancelablePaging = this.lmContextService.isUiPagingRequestWaitTimeEnabled;
    this.clearEmptyMessage();
    let chartName: string;
    if (this._chartName && this._chartName.length > 0) {
      chartName = this._chartName;
    } else if (this.listSpec.busListSpec.defaultChartName && this.listSpec.busListSpec.defaultChartName.length > 0) {
      chartName = this.listSpec.busListSpec.defaultChartName;
    } else {
      chartName = this.listSpec.busListSpec.charts[0].id;
    }

    this.xAxisId = this.listSpec.busListSpec.id + chartName + 'X';
    this.yAxisId = this.listSpec.busListSpec.id + chartName + 'Y';

    // was in @Input() set listSpec(), moved here and now using basic @Input() listSpec;
    if (this.lmListSpecUtilService.isMultiListPanelContent(this.listSpec)) {
      this.renderer.addClass(this.elementRef.nativeElement, 'multiListChart');
    } else {
      this.renderer.removeClass(this.elementRef.nativeElement, 'multiListChart');
    }

    if (this.lmListSpecUtilService.isColumnarView(this.listSpec)
      && this.listState
      && !this.listState.columnarOptions) {
      this.listState.columnarOptions = {};
    }
  }

  ngAfterViewInit() {
    if (this.getType() === 'aggregation') {
      return;
    }

    this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);
    this._chartNameChanged = false;
    this._fromDataViewChanged = false;
    this._periodIndexChanged = false;
    if (this.lmListChartSelectors) {
      this.lmListChartSelectors.dimensionChanged = false;
      this.lmListChartSelectors.totalChanged = false;
      this.lmListChartSelectors.orderByChanged = false;
      this.lmListChartSelectors.isAscendingChanged = false;
    }
    this._filterCriteriaChanged = false;
    const initialLoad = this.listState?.currentPageUrl ? false : true;
    setTimeout(() => this.build(initialLoad));
  }

  ngAfterViewChecked() {
    let initialLoad = this.listState?.currentPageUrl ? false : true;
    if (this.getType() === 'aggregation') {
      if (this._fromDataViewChanged) {
        this.lmListChartAggregation.fromDataView = this._fromDataView;
      }
      return;
    }
    let rebuild = false;
    if ((this._chartNameChanged || this._fromDataViewChanged || this._periodIndexChanged) && this.listSpec) {
      this._chartNameChanged = false;
      this._fromDataViewChanged = false;
      this._periodIndexChanged = false;
      rebuild = true;
    }

    if (this.lmListChartSelectors && this.lmListChartSelectors.dimensionChanged) {
      this.lmListChartSelectors.dimensionChanged = false;
      rebuild = true;
    }

    if (this.lmListChartSelectors && this.lmListChartSelectors.totalChanged) {
      this.listState.columnarOptions.selectedTotal = this.selectedTotal;
      this.lmListChartSelectors.totalChanged = false;
      rebuild = true;
    }

    if (this.lmListChartSelectors && this.lmListChartSelectors.orderByChanged) {
      this.lmListChartSelectors.orderByChanged = false;
      rebuild = true;
    }

    if (this.lmListChartSelectors && this.lmListChartSelectors.isAscendingChanged) {
      this.lmListChartSelectors.isAscendingChanged = false;
      rebuild = true;
    }

    if (this._filterCriteriaChanged) {
      this._filterCriteriaChanged = false;

      // 'this.filterCriteria === null' means clear filter was clicked and we need to treat this
      // as an initialLoad so initial values are retrieved for the search form.
      // 'this.filterCriteria === []' (empty array) means if initialLoad is false don't change that
      // so search form initial values are not retrieved.
      if (this.lmListUtilService.isUseAsSearchTargetList(this.listSpec) && this.filterCriteria === null) {
        initialLoad = true;
      }

      rebuild = true;
    }

    if (rebuild) {
      if (this.listState.columnarOptions) {
        this.listState.columnarOptions.selectedDimension = this.selectedDimension;
        this.listState.columnarOptions.selectedOrderBy = this.selectedOrderBy;
        this.listState.columnarOptions.isAscending = this.isAscending;
      }
      setTimeout(() => this.build(initialLoad));
    }
  }

  ngOnDestroy() {
    this.lmLoggerService.log([ this, this.instanceId, 'ngOnDestroy' ]);
  }

  protected loadManualData() {
    if (this.getType() === 'aggregation') {
      return;
    }
    if (this.listSpec.dependentList && !this.componentDestroyed) {
      this.build();
    }
  }

  protected onFormButtonClicked(columnDef: ListGridColumn, dataView: LMDataView, row: any, cell: any, navigationParams: any, event: any): void {
    // Handle click of the no data message button
    if (columnDef.displayField.linkNavigation ||
      columnDef.displayField.navigation ||
      columnDef.displayField.httpUrl ||
      navigationParams
    ) {
      const uiLinkEvent: LMUILinkEvent = { columnDef, dataView, event, navigationParams, options: { fromNoDataMessageFormButton: true } };
      this.lmListEventService.uiLinkEvent(uiLinkEvent);
    } else if (columnDef.displayField.type === AppConstants.FORMBUTTON ||
      columnDef.displayField.type === AppConstants.SUBFORM ||
      columnDef.displayField.type === AppConstants.FORMREFERENCE ||
      columnDef.displayField.type === AppConstants.LISTREFERENCE) {
      this.lmListEventService.formButtonEvent(<LMFormButtonEvent>{ columnDef, dataView, row, cell, event });
    }
  }

  protected fromDataViewChanged() {
    if (this.getType() === 'aggregation') {
      this.lmListChartAggregation.fromDataView = this._fromDataView;
      (this.lmListChartAggregation as LMListChartAggregationComponent).fromDataViewChanged();
      return;
    }

    // TODO this is different why
    if (this.listSpec.dependentList && !this.componentDestroyed && this.sohoBusyIndicator) {
      this.build();
    }
  }

  public isModified(): boolean {
    return false;
  }

  public showLegend() {
    return this.getChart().showLegend;
  }

  public showLines() {
    return this.getChart().showLabels;
  }

  public showLinesMobile() {
    return false;
  }

  public hideCenterLabel() {
    return true;
  }

  public isDateChart() {
    return this.getChart().showAsDateChart;
  }

  public isArea() {
    return this.getChart().showArea;
  }

  public isBubble() {
    return this.type === 'bubble';
  }

  public hideDots() {
    return false;
  }

  public isDonut() {
    return this.getChart().showAsDonut;
  }

  public legendPlacement() {
    if (this.type === 'donut' || this.type === 'pie') {
      return 'right';
    }
    return 'bottom';
  }

  public isStacked() {
    return this.getChart().showElements === 'Stacked';
  }

  public isNormalized() {
    return false;
  }

  public getLines() {
    return this.lines;
  }

  public isGrouped() {
    return this.getChart().showElements !== 'Stacked';
  }

  public animate() {
    return true;
  }

  public showTooltips() {
    return true;
  }

  public getDirtyRows(commitEdits: boolean = undefined): Array<LMDataView> {
    return [];
  }

  // temp functions to get chart to display
  public getBasicData() {
    return this.basicData;
  }

  public getId() {
    if (this.listSpec) {
      return this.listSpec.busListSpec.id + '_' + this._chartName;
    }
    return this._chartName;
  }
  public getType() {
    return this.type;
  }

  public setChartType() {
    const chart = this.getChart();
    let type: any = chart.chartType;
    const fields = chart.fields;

    type = (type === 'scatter') ? 'bubble' : type;
    type = (type === 'pie' && fields.length > 1) ?
      (this.lmListSpecUtilService.isCubeView(this.listSpec) && chart.orientation === 'column' ? 'pie' : 'bar') : type;
    type = (type === 'pie' && chart.showAsDonut) ? 'donut' : type;
    type = (type === 'line' && chart.showArea) ? 'area' : type;
    if (type === 'bar') {
      if (chart.showBars === 'Vertically') {
        type = 'column-grouped';
        if (chart.showElements === 'Stacked') {
          type = 'column-stacked';
        }
      } else if (chart.showBars === 'Horizontally') {
        type = 'bar-grouped';
        if (chart.showElements === 'Stacked') {
          type = 'bar-stacked';
        }
      } else {
        type = 'column-grouped';
      }
    }
    this.type = type;
  }

  public getChartAnimate() {
    return false;
  }

  public getLabels() {
    return this._labels;
  }

  public refresh(): Observable<any> {
    if (this.getType() === 'aggregation' && this.lmListChartAggregation) {
      return this.lmListChartAggregation.refresh();
    }
    return new Observable<any>(observer => {
      this.build(false); // need to refresh! this should be in an observable!.
      observer.next(true);
      observer.complete();
    });
  }

  public getDataViewSet(): LMDataViewSet {
    if (this.getType() === 'aggregation'
      && this.lmListChartAggregation) {
      return this.lmListChartAggregation.getDataViewSet();
    }
    return this.dataViewSet;
  }

  public setDirtyIndicator(row: number, cell: number, showDirty: boolean) {
    // TODO implement me.
  }

  public updateDataViewTransaction(key: number, status: string, message: string): void {
    // TODO implement me.
  }

  public updateDataView(key: number, dataView: LMDataView) {
    // this.sohoDataGridComponent.updateRow(key, dataView);
  }

  public getDataViewIndex(event: ChartEvent): number {
    if (!event.data) {
      return -1;
    }
    if (event.data.ref) {
      return event.data.ref;
    }
    if (event.data && event.data.length === 1 && event.data[0].ref) {
      return event.data[0].ref;
    }
    if (event.data.data && event.data.data.ref) {
      return event.data.data.ref;
    }
    if (event.data.data && event.data.data.length === 1 && event.data.data[0].ref) {
      return event.data.data[0].ref;
    }
    return -1;
  }

  public getSelectedRow(): number {
    const selectedRows = this.getSelectedRows();

    if (selectedRows.length === 1) {
      return selectedRows[0];
    } else {
      return 0;
    }
  }

  public getSelectedRows(): Array<number> {
    if (this.listSpec.busListSpec.selection === 'disabled') {
      return [];
    }
    // let selectedRows: Array<number> = [];

    if (this.getType() === 'aggregation'
      && this.lmListChartAggregation) {
      return this.lmListChartAggregation.getSelectedRows();
    }

    const index = (this.lmListSpecUtilService.isCubeView(this._listSpec)) ? -1 : this.getDVindex();
    // let dataGridSelectedRows: SohoDataGridSelectedRow[] = this.sohoDataGridComponent.getSelectedRows();
    // for (let i = 0, len = dataGridSelectedRows.length; i < len; i++) {
    //   selectedRows.push(dataGridSelectedRows[i].idx);
    // }
    // return selectedRows;

    return [ index ];
  }

  protected get listChartElementTitleClasses(): string {
    return this.lmListSpecUtilService.isDashBoardContent(this.listSpec) ? 'lm-list-chart-element-title' : '';
  }

  private get selectedDimension() {
    if (this.lmListChartSelectors) {
      return this.lmListChartSelectors.selectedDimension;
    } else
    if (this.listState.columnarOptions
      && this.listState.columnarOptions.selectedDimension) {
      return this.listState.columnarOptions.selectedDimension;
    } else {
      return undefined;
    }
  }

  private get selectedTotal() {
    if (this.lmListChartSelectors) {
      return this.lmListChartSelectors.selectedTotal;
    } else
    if (this.listState.columnarOptions
      && this.listState.columnarOptions.selectedTotal) {
      return this.listState.columnarOptions.selectedTotal;
    } else {
      return undefined;
    }
  }

  private get selectedOrderBy() {
    if (this.lmListChartSelectors) {
      return this.lmListChartSelectors.selectedOrderBy;
    } else
    if (this.listState.columnarOptions
      && this.listState.columnarOptions.selectedOrderBy) {
      return this.listState.columnarOptions.selectedOrderBy;
    } else {
      return undefined;
    }
  }

  private get isAscending() {
    if (this.lmListChartSelectors) {
      return this.lmListChartSelectors.isAscending;
    } else
    if (this.listState.columnarOptions) {
      return this.listState.columnarOptions.isAscending;
    } else {
      return true;
    }
  }

  protected filterCriteriaChanged() {
    // See the actual processing of the changed filterCriteriaChanged is in ngAfterViewChecked
    this._filterCriteriaChanged = true;
    this.changeDetectorRef.markForCheck();
  }

  public onContextMenuItemSelected(actionReference: LMBusActionReference, selectedDataView?: LMDataView): void {
    // TODO
  }

  public disableSaveInUserListViewMenu(): boolean {
    // TODO: The saved search depends on filter criteria.
    // TODO: Enable or disable based on sort order that is part of LMSearchState.
    return !this.listState.filterCriteria?.length;
  }

  public unSelectAllRows() {
    if (this.getType() === 'aggregation'
      && this.lmListChartAggregation) {
      // This will go to lm-datagrid-base component
      this.lmListChartAggregation.unSelectAllRows();
    }
  }

  public setSelectedRows(rows: Array<number>, scrollIntoView?: boolean) {    // [1, 3, 5 ]
    if (this.getType() === 'aggregation'
      && this.lmListChartAggregation) {
      this.lmListChartAggregation.setSelectedRows(rows, scrollIntoView);
      return;
    }
    setTimeout(() => {
      this.lmChartComponent = this.lmChartComponents.toArray()[0];
      if (this.lmChartComponent) {
        this.lmChartComponent.setSelectRef(rows[0]);
      }
    }, 100);
  }

  public activateRow(row: number, scrollIntoView?: boolean) {
    // if (this.listSpec.busListSpec.selection === 'disabled') {
    //   return; // safety
    // }
    //  this.sohoDataGridComponent.activateRow(row);
    if (this.getType() === 'aggregation'
      && this.lmListChartAggregation) {
      return this.lmListChartAggregation.activateRow(row);
    }
  }

  public activatedRow(): number {
    return -1;
  }

  onSelected(chartEvent: ChartEvent) {

    const idx = (this.hasChartData && this.getSelectedRow() != null) ? this.getSelectedRow() : 0;

    const listRowSelectedEvent: LMListRowSelectedEvent = {
      event: chartEvent.event,
      rows: [ {
        idx,
        data: {},
        elem: null
      } ]
    };

    this.lmListEventService.listRowSelectedEvent(listRowSelectedEvent);
    this.lmLoggerService.log([ this, this.instanceId, chartEvent.event, chartEvent.ui, chartEvent.data ]);
  }

  onUnselected(chartEvent: ChartEvent): void {
    // todo: implement me!
  }

  // onActivated(chartEvent: ChartEvent): void {
  //   // this.listRowActivated.emit(event);
  //    this.lmLogger.log([this, this.instanceId, chartEvent.event, chartEvent.ui, chartEvent.data]);
  // }

  onRendered(chartEvent: ChartEvent): void {
    // this.listRowDeactivated.emit(event);
    this.lmLoggerService.log([ this, this.instanceId, chartEvent.event ]);
  }

  onContextMenu(chartEvent: ChartEvent): void {

    if (chartEvent instanceof MouseEvent || (!chartEvent.data && !chartEvent.event.data)) {
      return;
    }

    const listRowSelectedEvent: LMListRowSelectedEvent = {
      event: chartEvent.event,
      rows: [ {
        idx: this.getDataViewIndex(chartEvent),
        data: {},
        elem: null
      } ]
    };

    // force a row selection before bringing up the the right click menu
    this.lmListEventService.listRowSelectedEvent(listRowSelectedEvent);

    const selectedChartRow: LMContextMenuEvent = {
      originalEvent: chartEvent.event,
      row: this.getDataViewIndex(chartEvent),
      item: {},
      cell: 1,
      type: 'chart'
    };
    this.ngZone.run(() => {
      this.lmListEventService.contextMenuEvent(selectedChartRow);
    });
  }

  // private buildChart() {
  //   this.initialize();
  //   this.build();
  //   this.events();
  // }
  //
  // private initialize() {
  //   if (!this.listSpec) {
  //     return;
  //   }
  //
  //   this.showAsCard = (!this.listSpec.showAsMingleWidget && !this.lmListSpecUtilService.isDashBoardContent(this.listSpec));
  // }

  public onAxisChanged(event: ChartAxisChangedEvent) {
    this.selectedXAxis = event.xSelectionIndex;
    this.selectedYAxis = event.ySelectionIndex;
    this.buildChartData(this.dataViewSet, this.listSpec);
    this.basicData = this._basicData;
  }

  protected build(initialLoad = true) {
    if (!this.listSpec || !this._chartName) {
      return;
    }

    this.setChartType();

    if (this.lmListSpecUtilService.isCubeView(this.listSpec)
      && !(this.lmListSpecUtilService.isDashBoardContent(this.listSpec))) {
      // Data is available for non dashboard types. Build the chart using the data.
      if (this.dataViewSet) {
        // Data is available, so build chart data directly.
        this.buildChartData(this.dataViewSet, this.listSpec);
        this.basicData = this._basicData;
      }
      this.setEmptyMessage();
      return;
    }

    this.cancelOutstandingPagingRequest();

    if (this.listSpec.dependentList) {
      if (this.fromDataView === undefined) {
        return; // safety
      }

      if (this.fromDataView === null) {
        // disabled flag should be set at this point! That makes disabling
        // the component here seem like we are doing disabled checking in 2 spots.
        // todo: ppatton Look into more consistent (and single) way of disabling list-grid, list-view, etc...
        // this.disableComponent();

        /**
         * emitting the dataLoaded event with a null so the lm-list object
         * can responsd appropriately.
         * todo: ppatton again, why do this here?! shouldn't the lm-list already now it's been disabled?!
         */
        setTimeout(() => this.lmListEventService.dataLoadedEvent(null));
        return;
      }

      if (!this._fromDataView) {
        this.dataViewSet = undefined;
        this.buildChartData(this.dataViewSet, this.listSpec);
        this.basicData = this._basicData;

        /**
         * emitting the dataLoaded event with a undefined dataView should
         * cause the lm-list to fully disable.
         * NOTE: Must be called from a timeout to ensure this component is available to the observer.
         */
        setTimeout(() => this.lmListEventService.dataLoadedEvent(null));
        return;
      }
    }

    // todo 1. deal with tree view
    // todo 2. deal with cube options - probably need to be in url somewhere set on the server

    // let pageSize = this.listPersonalization.pageSize;

    // reset to initial url
    let url = this.buildInitialPageUrl();
    // Once the initial data has been loaded, use a filter pageop to facilitate
    // receiving a searchDataView without initial value rules so any entered
    // filter criteria is not reset.
    if (!initialLoad) {
      url = this.lmUrlUtilService.updateUrlParams(url, { pageop: 'filter' });
    }

    // // -------------------------------------------------------------
    // // Get the base url
    // // -------------------------------------------------------------
    // const url: string = this.listSpec.dependentList ?
    //   this.urlUtilService.buildRelatedUrl(this.listSpec.initialRelatedData, this.fromDataView) :
    //   this.listSpec.initialDataUrl;

    // -------------------------------------------------------------
    // Get pageSize to pass into the paging service
    // -------------------------------------------------------------
    const pageSize = this.getType() === 'aggregation' ? 0 : -1; // this.sohoDataGridComponent.pageSize();
    const postContent = this.lmListGridPagingService.buildPostContent(this.listSpec);// this.lmUrlUtilService.buildSelectDataViewPagingRequest(this.selectRequestData);
    const isManualLoad = this.isManualLoading();

    url = this.lmUrlUtilService.removeFilterCriteria(url);

    if (this.lmListSpecUtilService.isCubeView(this.listSpec)
      && (this.lmListSpecUtilService.isDashBoardContent(this.listSpec))) {
      let delimiter = (url.indexOf('?') > -1) ? '&' : '?';
      // Add dimension and chart name for Dashboard panel cube views.
      if (this.listSpec.cubeOptions.dimensionName) {
        url = url + delimiter + 'dimensionName=' + this.listSpec.cubeOptions.dimensionName;
        delimiter = '&';
      }
      url = url + delimiter + 'chartName=' + this._chartName;
      url = url + delimiter + 'dashboardView=true';
    }

    if (this.lmListSpecUtilService.isColumnarView(this.listSpec)) {
      if (this.selectedDimension) {
        const selectedDisplayField = this._listSpec.busListSpec.displayFields.find(x => x.fieldId === this.selectedDimension);
        if (selectedDisplayField === undefined || (selectedDisplayField && selectedDisplayField.isTotal)) {
          this.listState.columnarOptions.selectedDimension = undefined;
        } else {
          url = this.lmUrlUtilService.removeParam(url, 'sortOrderName');
          url = this.lmUrlUtilService.appendToQueryString(url, 'gbfn=' + this.selectedDimension);

          this.listState.currentPageUrl = this.lmUrlUtilService.appendToQueryString(
            this.lmUrlUtilService.removeParam(this.listState.currentPageUrl, 'sortOrderName'),
            'sortOrderName=' + this.selectedDimension);

          this.listState.currentPageUrl = this.lmUrlUtilService.appendToQueryString(
            this.lmUrlUtilService.removeParam(this.listState.currentPageUrl, 'pageop'), 'pageop=sort');
        }
      }

      if (this.selectedOrderBy) {
        url = this.lmUrlUtilService.appendToQueryString(url, 'obfn=' + this.selectedOrderBy);
      }

      if (this.isAscending !== undefined) {
        url = this.lmUrlUtilService.removeParam(url, 'isAscending');
        url = this.lmUrlUtilService.appendToQueryString(url, 'asc=' + this.isAscending);

        this.listState.currentPageUrl = this.lmUrlUtilService.appendToQueryString(
          this.lmUrlUtilService.removeParam(this.listState.currentPageUrl, 'isAscending'),
          'isAscending=' + this.isAscending);
      }

      url = this.lmUrlUtilService.appendToQueryString(url, 'chartName=' + this._chartName);
      // url = this.lmUrlUtilService.removeFilterCriteria(url);
      // filterCriteria = this.listState.filterCriteria;
    }

    // -------------------------------------------------------------
    // request the first page of records and log how long it took
    // -------------------------------------------------------------
    this.lmLoggerService.time({ id: 'LMListChart.initialPage() ' + this.instanceId });
    // Hide chart when fetching data
    this.handleCancellableRequest();
    this.hasChartData = false;
    this.lmBusyIndicatorService.showBusyIndicator(this.sohoBusyIndicator);
    this.pagingSubscription = this.lmListGridPagingService.initialPageFiltered(url, this.getCombinedFilterCriteria(),
      pageSize, postContent, isManualLoad).subscribe((listPagingResponse: LMListPagingResponse) => {
      this.lmLoggerService.timeEnd('LMListChart.initialPage() ' + this.instanceId, [ this, listPagingResponse.dataViewSet ]);

      if (this.handleCancelableResponse(listPagingResponse)) {
        return;
      }

      this.setEmptyMessage();
      if (listPagingResponse.status === 'COMPLETED') {
        this.dataViewSet = listPagingResponse.dataViewSet;
        this.savedSearches = listPagingResponse.savedSearchDataViewSet;
        this.listState.currentPageUrl = this.dataViewSet.pagingUrls.reloadPageUrl;
        this.postLoadChart(listPagingResponse);
      } else {
        this.basicData = [];
        this.lmErrorUtilService.handleError(listPagingResponse.message, listPagingResponse.details,
          listPagingResponse.status, listPagingResponse.message);
        if (this.lmListSpecUtilService.isCubeView(this.listSpec)) {
          if (this.lmListSpecUtilService.isDashBoardContent(this.listSpec)) {
            this.lmListEventService.cubeDataLoadedEvent(listPagingResponse);
          }
          return;
        }
        this.lmListEventService.dataLoadedEvent(listPagingResponse);
      }
      this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
    });
  }

  // Changes here should be reflected in lm-list-chart-aggregation.ts::buildInitalPageUrl().
  private buildInitialPageUrl(): string {
    let url;
    if (this.listSpec.dependentList) {
      if (this.listState.currentPageUrl
        && this._fromDataView.resourceId === this.listState.fromResourceId
        && this.lmUrlUtilService.allCsksMatchContext(this.listState.currentPageUrl)
      ) {
        // if the fromDataView hasn't changed and there is a currentPageUrl then load that
        // to keep our position in the dependent list.
        url = this.listState.currentPageUrl;
      } else {
        // else resolve template against the fromDataView's resourceId
        const compiledUrlTemplate = urltemplate.parse(this.listUrlInfo.initialDataUrl);
        url = compiledUrlTemplate.expand({ resourceId: this._fromDataView.resourceId });
      }
    } else if (this.listState.currentPageUrl
      && this.lmUrlUtilService.allCsksMatchContext(this.listState.currentPageUrl)
      && this.lmUrlUtilService.hasSameParamValue(this.listState.currentPageUrl, this.listUrlInfo.initialDataUrl, 'filter')
    ) {
      url = this.listState.currentPageUrl;
    } else {
      url = this.listUrlInfo.initialDataUrl;
    }
    return url;
  }

  private handleCancellableRequest(): void {
    if (this.implementsCancelablePaging && this.cancelPagingNotifier$) {
      this.cancelPagingNotifier$.next(true);
      this.cancelPagingNotifier$.complete();
      this.cancelPagingNotifier$ = null;
    }
  }

  private handleCancelableResponse(response: LMListPagingResponse): boolean {
    if (this.implementsCancelablePaging) {
      if (response.status === 'STARTED') {
        this.lmListEventService.cancelablePagingEvent(<LMCancelablePagingEvent>{ state: 'started', cancelablePagingNotifier: response.cancelablePagingNotifier });
        this.cancelPagingNotifier$ = response.cancelablePagingNotifier;
        return true;
      } else if (response.status === 'WAITING') {
        this.lmListEventService.cancelablePagingEvent(<LMCancelablePagingEvent>{ state: 'waiting' });
        return true;
      } else if (response.status === 'CANCELED') {
        this.lmListEventService.cancelablePagingEvent(<LMCancelablePagingEvent>{ state: 'canceled' });
        this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
        return true;
      } else {
        this.cancelPagingNotifier$ = null;
        this.lmListEventService.cancelablePagingEvent(<LMCancelablePagingEvent>{ state: 'finished' });
        return false;
      }
    } else {
      return false;
    }
  }
  // data: [{name: 'January', tooltip: 'This is a January', value: {x: 5, y: 3, z: 3}

  private buildChartData(dataViewSet: LMDataViewSet, listSpec: LMListSpec) {

    this.statesArray = [];

    let chartName = '';
    const chartType = this.getType();

    if (this._chartName && this._chartName.length > 0) {
      chartName = this._chartName;
    } else if (listSpec.busListSpec.defaultChartName && listSpec.busListSpec.defaultChartName.length > 0) {
      this._chartName = listSpec.busListSpec.defaultChartName;
    } else {
      this._chartName = listSpec.busListSpec.charts[0].id;
    }

    const chart = listSpec.busListSpec.charts[chartName];
    const legendFieldId = chart.legend;

    if (chart.orientation === 'periodView') {
      const periodData = this.getDataSetForPeriodViewOrientation(dataViewSet);
      if (periodData !== null) {
        this._basicData = periodData.chartData;
        this.hasChartData = (this._basicData && this._basicData[0] && this._basicData[0].data && this._basicData[0].data.length > 0);
      } else {
        this._basicData = [ { data: [] } ];
        this.hasChartData = false;
        this.setNoChartableDataMessage();
      }
      return;
    }

    let dataLength = 0;

    if (dataViewSet) {
      // if(dataViewSet.data.length > self.MAX_PIE_SLICES)
      //   dataLength = self.MAX_PIE_SLICES;
      // else
      dataLength = dataViewSet.data.length;
    }

    let fields = chart.fields;
    const fieldsFormatOptions = new Array(fields.length);
    if (this.lmListSpecUtilService.isCubeView(this.listSpec)) {
      if (dataViewSet && dataViewSet.chartPeriods) {
        fields = dataViewSet.chartPeriods[chartName][this.periodIndex].fields;
      }
    }

    if (this.lmListSpecUtilService.isColumnarView(this.listSpec)
      && this.selectedTotal
      && this.selectedTotal !== 'COLUMNAR_All') {
      const dispFld: LMListDisplayField = this.listSpec.busListSpec.displayFields.find(x => x.fieldId === this.selectedTotal);
      const fld: LMChartField = { fieldId: dispFld.fieldId, label: dispFld.label, type: dispFld.type };
      fields = [ fld ];
    }

    const xAxis = Array<any>();
    const yAxis = Array<any>();
    let otherTotal = 0;
    let fullTotal = 0;

    // let selectedXAxis = 0;
    // let selectedYAxis = 0;
    // let zAxisTitle = '';

    if (chartType === 'bubble' || chartType === 'scatter') {
      for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        if (field.axis === 'X') {
          xAxis.push(field);
        } else if (field.axis === 'Y') {
          yAxis.push(field);
        }
      }
    }
    let chartData: Array<SohoDataSetItem> = [];

    const dataArray = new Array(dataLength);
    for (let i = 0; i < dataLength; i++) {
      dataArray[i] = new Array(fields.length);
    }

    const rowTitles = this.buildChartRowTitles(dataViewSet);
    const specFields = this.lmListUtilService.buildSpecFields(this.listSpec.busListSpec.displayFields);
    const categories = this.buildChartCategories(dataViewSet, chartName, specFields);
    const dataviewIndexMap = new Array(fields.length);

    if (dataViewSet) {
      // setup the data object for a line chart and Gap
      if (chartType === 'line' || chartType === 'bubble' || chartType === 'scatter' || chartType === 'area' || chartType === 'gap') {
        for (let dataSets = 0; dataSets < rowTitles.length; dataSets++) {
          const dataSet: SohoDataSetItem = { name: rowTitles[dataSets], data: Array<SohoChartData>() };
          chartData.push(dataSet);
        }
      }
      const xField = xAxis[this.selectedXAxis];
      const yField = yAxis[this.selectedYAxis];
      // if (dataViewSet.data[i].id === chart.pointSize) {
      //   zAxisTitle = dataview.data[i];
      // }
      // let xFieldObj = typeof xField === 'object' ? xField.label : xField;
      let xFieldTitle = xField ? this.lmFormatUtilService.formatMessageRule(xField.label, undefined) : undefined;
      // let yFieldObj = typeof yField === 'object' ? yField.label : yField;
      let yFieldTitle = yField ? this.lmFormatUtilService.formatMessageRule(yField.label, undefined) : undefined;
      let zFieldTitle = '';
      if (chart.pointSize) {
        zFieldTitle = this.lmFormatUtilService.formatMessageRule(chart.pointSize, dataViewSet.data[0]);
      }
      let record: SohoDataSetItem = { data: Array<SohoChartData>() };
      for (let t = 0; t < dataLength; t++) {
        if (chartType !== 'donut' && chartType !== 'pie' && chartType !== 'area' && chartType !== 'line' && chartType !== 'gap') {
          record = { data: Array<SohoChartData>() };
          record['name'] = categories[t];
          if (chartType === 'bubble' || chartType === 'scatter') {
            // let xFieldObj = typeof xField === 'object' ? xField.label : xField;
            xFieldTitle = xField ? this.lmFormatUtilService.formatMessageRule(xField.label, undefined) : undefined;
            // let yFieldObj = typeof yField === 'object' ? yField.label : yField;
            yFieldTitle = yField ? this.lmFormatUtilService.formatMessageRule(yField.label, undefined) : undefined;
            record['labels'] = { name: '', value: { x: xFieldTitle, y: yFieldTitle, z: zFieldTitle } };
          }
        }

        if ((chartType !== 'donut' && chartType !== 'pie' && chartType !== 'area' && chartType !== 'line') && t === this.getSelectedRow()) {
          record['selected'] = true;
        }
        const dataView = dataViewSet.data[t];
        const bubbleRecordData = { value: {}, tooltip: '' };
        let bubbleRecord = {};

        const axisLabels = {
          value: {
            x: xFieldTitle,
            y: yFieldTitle,
          },
          tooltip: ''
        };

        if (chartType === 'bubble') {
          axisLabels.value['z'] = zFieldTitle;
        }
        let stateFieldLabel = '';
        let stateFieldValue = 0;
        if (chartType === 'bubble' || chartType === 'scatter') {
          if (legendFieldId) {
            stateFieldValue = this.getFieldValue(legendFieldId, dataView.fields[legendFieldId]);

            if (!this.statesArray[stateFieldValue]) {

              if (chart.legendStates && chart.legendStates.length > 0) {
                stateFieldLabel = this.getStateDisplay(stateFieldValue, chart.legendStates);
              }
              if (stateFieldLabel.length === 0 && dataView.fields[legendFieldId]) {
                const legendFieldItem = this.lmFormatUtilService.findStateItem({ value: stateFieldValue, stateValues: dataView.fields[legendFieldId].stateValues });
                if (legendFieldItem !== null) {
                  stateFieldLabel = legendFieldItem.label;
                }
              }
            }
          }

          if (!this.statesArray[stateFieldValue]) {
            bubbleRecord = {};
            bubbleRecord['data'] = [];
            //      bubbleRecord[ 'tooltip' ] = '';
            bubbleRecord['name'] = stateFieldLabel;
            bubbleRecord['labels'] = { name: '', value: axisLabels };
            this.statesArray[stateFieldValue] = bubbleRecord;
          }

          bubbleRecordData.value['x'] = this.getFieldValue(xField, dataView.fields[xField.fieldId]);
          bubbleRecordData.value['y'] = this.getFieldValue(yField, dataView.fields[yField.fieldId]);

          // if a fixedSclaePointSize is defined use it before setting standard pointsize.
          if (chart.fixedScalePointSize) {
            bubbleRecordData.value['z'] = chart.fixedScalePointSize;
          } else {
            bubbleRecordData.value['z'] = chart.chartType === 'scatter' ? 1 : this.getFieldValue(chart.pointSize, dataView.fields[chart.pointSize]);
          }

          bubbleRecordData['name'] = ''; // dataView.fields[ chart.pointSize ].label;

          if (this.listSpec.busListSpec.detailFields) {
            bubbleRecordData.tooltip = this.lmListUtilService.buildDetailFieldsAsTooltip(dataView, this.listSpec.busListSpec.detailFields);
          } else {
            bubbleRecordData.tooltip = this.buildDefaultBubbleTooltip(bubbleRecordData.value['x'], bubbleRecordData.value['y'],
              bubbleRecordData.value['z'], axisLabels);
          }
          if (bubbleRecordData.value['z'] <= 0) {
            continue;
          }

          this.statesArray[stateFieldValue].data.push(bubbleRecordData);

        } else {
          for (let s = 0; s < fields.length; s++) {
            const specDecSize = this.listSpec.busListSpec.fields[fields[s].fieldId].decSize;
            const datviewPrecision = dataView.fields[fields[s].fieldId].precision;

            const options: LMTransformOptions = {
              precision: datviewPrecision,
              decSize: specDecSize,
              displayZero: true
            };
            const fieldVal: number = this.getFieldValue(fields[s], dataView.fields[fields[s].fieldId]);

            const sohoChartData: SohoChartData = { name: '', value: 0 };
            fieldsFormatOptions[s] = options;

            dataArray[t][s] = fieldVal;
            dataviewIndexMap[t] = t;

            // let type = fields[ s ].type
            const name = (chartType === 'line' || chartType === 'area') && chart.showAsDateChart ? (new Date(categories[t]).toLocaleDateString()) : categories[t];

            sohoChartData['name'] = (chartType === 'donut' || chartType === 'line' || chartType === 'area' || chartType === 'gap'
              || chartType === 'pie' || chartType === 'donut') ? name : rowTitles[s];
            // dataView.fields[fields[s].fieldId].label;
            if (chartType === 'line' || chartType === 'area') {
              sohoChartData['value'] = fieldVal;
            } else {
              sohoChartData['value'] = fieldVal;
            }

            // ref to dataview Index so we will know where the data came from.
            sohoChartData['ref'] = t;

            if (t === this.getSelectedRow() && ((chartType === 'pie') || chartType === 'donut')) {
              sohoChartData['selected'] = true;
            }

            if (chart.showAsDateChart) {
              sohoChartData['tooltip'] = rowTitles[s] + '   ' + fieldVal + '</br>' + categories[t];
            } else if (chartType === 'donut' || chartType === 'pie') {
              sohoChartData['tooltip'] = categories[t] + '</br><b>' + this.lmFormatUtilService.bcdToDisplay(fieldVal.toString(), options) + ' - {{percent}}</b>';
            }

            if (chartType === 'line' || chartType === 'area' || chartType === 'gap') {
              chartData[s].data.push(sohoChartData);
            } else {
              record.data.push(sohoChartData);
            }

            if (this.listSpec.busListSpec.detailFields) {
              record['tooltip'] = this.lmListUtilService.buildDetailFieldsAsTooltip(dataView, this.listSpec.busListSpec.detailFields);
            } else if (chartType.startsWith('column') || chartType.startsWith('bar')) {
              // noop
            } else {
              record['tooltip'] = fields[s].fieldId;
            }
          }
        }

        if ((chartType !== 'line' && chartType !== 'bubble' && chartType !== 'scatter' && chartType !== 'area' && chartType !== 'gap')) {
          chartData.push(record);
        }
      }
      this.xAxisFields = xAxis;
      this.yAxisFields = yAxis;

      let topRecords: Array<SohoChartData>;
      if (chartType === 'pie' || chartType === 'donut') {
        // for a pie of donut chart put the data together another way.

        let selectedDimensionFieldSpec: Array<LMListDisplayField>;
        let elementValueFieldSpec: LMSpecField;
        if (this.selectedDimension) {
          selectedDimensionFieldSpec = this.listSpec.busListSpec.displayFields.filter((specField: LMListDisplayField) => {
            // you can only have one pie
            if (this.selectedDimension === specField.fieldId) {
              return specField;
            } else
            if (chart.fields[0].fieldId === specField.fieldId) {
              return specField;
            }
          });
        } else if (this.listSpec.busListSpec.fields.hasOwnProperty(chart.fields[0].fieldId)) {
          elementValueFieldSpec = this.listSpec.busListSpec.fields[chart.fields[0].fieldId];
        }

        this.setChartElementTitle(chartName, fields, rowTitles);

        record.data = this.getTopValueRecords(record.data);
        chartData = Array<SohoDataSetItem>();
        topRecords = record.data.slice(0, (AppConstants.CHART_MAX_PIE_SLICES - 1));  // leave 1 position for the other slice

        // total up the amt so a percent can be figured out for the pie, also total the data that does not make up the CHART_MAX_PIE_SLICES - 1 so we know the otherTotal
        for (let i = 0; i < record.data.length; i++) {
          if (i > (AppConstants.CHART_MAX_PIE_SLICES - 1)) {
            otherTotal += (record.data[i].value as number);
          }
          fullTotal += (record.data[i].value as number);
        }

        // Add in the other node if any other value exists
        if (otherTotal > 0) {
          const sohoChartOtherData: SohoChartData = { name: '', value: 0 };
          sohoChartOtherData['name'] = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('OtherLabel'), null);  // dataView.fields[fields[s].fieldId].label;
          sohoChartOtherData['value'] = otherTotal;
          topRecords.push(sohoChartOtherData);
        }

        // set the display for the chart to be the label instead of the value
        if (this.showLegend()) {
          this.lines = {};
        } else {
          this.lines = { show(d) {
            return d.name + '  (' + (parseFloat(d.percent) * 100).toFixed(2) + '%)';
          }
          };
        }

        topRecords = this.removeZeroValues(topRecords);

        topRecords.map((item: SohoChartData) => {
          const sliceValue: number = (item.value as number);
          const slicePercent = ((item.value as number) / fullTotal) * 100;
          let displayValue = String(item.value);

          if (elementValueFieldSpec) {
            if (elementValueFieldSpec.type === AppConstants.PERCENT) {
              displayValue = slicePercent.toFixed(2) + '%';
            } else if (elementValueFieldSpec.type === AppConstants.BCD) {
              const precision = fields[0]?.fieldId ? dataViewSet.data[0]?.fields[fields[0]?.fieldId]?.precision : undefined;
              const options: LMTransformOptions = {
                precision: (precision !== undefined) ? precision : elementValueFieldSpec.decSize,
                decSize: elementValueFieldSpec.decSize,
                displayZero: true
              };
              displayValue = this.lmFormatUtilService.bcdToDisplay(item.value.toString(), options);
            }
          }

          if (selectedDimensionFieldSpec) {
            // we can use 0 here for now since we do not support more than one element for a pie chart
            if (selectedDimensionFieldSpec[0].type === AppConstants.PERCENT) {
              displayValue = slicePercent.toFixed(2) + '%';
            }
          }

          item['tooltip'] = item.name + '</br><b>' + displayValue + '</b>';
        });

        chartData.push({ data: topRecords });
      }
    }
    if (chartType === 'bubble' || chartType === 'scatter') {
      // states array is built using the index of the state to sort records into states. Chart does not like chart data that uses an
      // array that has undefined items. We need to rebuild te array without undefined items.
      const cleanArray = this.statesArray.filter(function(element) {
        if (element) {
          return element;
        }
      });
      this._basicData = cleanArray;
    } else {
      this._basicData = chartData;
    }
    this.lmBusyIndicatorService.hideBusyIndicator(this.sohoBusyIndicator);
    //    this.changeDetectorRef.markForCheck();
    //    this.changeDetectorRef.detectChanges();

    // temp until control support empty data sets
    this.hasChartData = (this._basicData && this._basicData[0] && this._basicData[0].data && this._basicData[0].data.length > 0);
    if (!this.hasChartData && dataLength > 0) {
      this.setNoChartableDataMessage();
    }
  }

  private hasChartElementTitle(chartName: string, fields: LMListDisplayField[]): boolean {
    const chartType = this.getType();
    if ((chartType === 'pie' || chartType === 'donut') && fields.length === 1) {
      return fields[0]?.hasChartElementTitle;
    }
    return false;
  }

  private setChartElementTitle(chartName: string, fields: LMListDisplayField[], rowTitles: string[]) {
    if (this.hasChartElementTitle(chartName, fields)) {
      this.chartElementTitle = rowTitles[0];
    }
  }

  private getStateDisplay(value, states): string {
    let retVal = value;
    for (let i = 0; i < states.length; i++) {
      // tslint:disable-next-line:triple-equals > using non-strict equality to evaluate 0, '0', 0.00, '0.00' as zero
      if (states[i].value == value) {
        retVal = states[i].label;
      }
    }
    return retVal;
  }

  private buildDefaultBubbleTooltip(xAxis: number, yAxis: number, zAxis: number, labels): string {
    let tooltip = '';
    const xTitle = labels ? labels.value.x : 'X Axis';
    const yTitle = labels ? labels.value.y : 'Y Axis';
    const zTitle = labels ? labels.value.z : 'Z Axis';

    tooltip += '<table><tbody><tr><td style="text-align: left; width: 40%; word-wrap: normal;">' + xTitle + '</td>'
      + '<td style="text-align: right; width: 60%; word-wrap: normal;">' + xAxis + '</td></tr>';
    tooltip += '<tr><td style="text-align: left; width: 40%; word-wrap: normal;">' + yTitle + '</td>'
      + '<td style="text-align: right; width: 60%; word-wrap: normal;">' + yAxis + '</td></tr>';
    if (zTitle && zTitle.length > 0) {
      tooltip += '<tr><td style="text-align: left; width: 40%; word-wrap: normal;">' + zTitle + '</td>'
        + '<td style="text-align: right; width: 60%; word-wrap: normal;">' + zAxis + '</td></tr>';
    }

    tooltip += '</tbody></table>';
    return tooltip;
  }

  private getDataSetForPeriodViewOrientation(dataViewSet: LMDataViewSet): any {
    if (dataViewSet && dataViewSet.chartPeriods
      && dataViewSet.chartPeriods[this._chartName][this.periodIndex]
      && dataViewSet.chartPeriods[this._chartName][this.periodIndex].periodDataSet) {
      const fields = this.listSpec.busListSpec.charts[this._chartName].fields;
      const periodDataSet = dataViewSet.chartPeriods[this._chartName][this.periodIndex].periodDataSet;
      const categories = []; // This is the X - axis (usually the date /time component)
      const seriesName = []; // This is the field labels or chart legend
      const dataArray = new Array(periodDataSet.length); // Data point for each field. Chart plots (period, fieldValue)

      for (let i = 0, len = periodDataSet.length; i < len; i++) {
        const period = periodDataSet[i];
        categories[i] = period.period;
        dataArray[i] = new Array(fields.length);

        for (let j = 0, fieldLen = fields.length; j < fieldLen; j++) {
          const key = j + '';

          if (i === 0) {
            seriesName[j] = period[key].label;
          }
          dataArray[i][j] = period[key].value;
        }
      }

      const chartData: Array<SohoDataSetItem> = [];
      for (let i = 0, len = fields.length; i < len; i++) {
        const record: SohoDataSetItem = { data: Array<SohoChartData>() };
        record['name'] = seriesName[i];
        if (i === 0) {
          record['selected'] = true;
        }
        for (let j = 0, len2 = categories.length; j < len2; j++) {
          const sohoChartData: SohoChartData = { name: '', value: 0 };
          sohoChartData['name'] = categories[j];
          sohoChartData['value'] = dataArray[j][i];
          sohoChartData['ref'] = i;
          record.data.push(sohoChartData);
        }
        chartData.push(record);
      }
      return { chartData };
    }
    return null;
  }

  // private getBubbleValue(): BubbleCordinates {
  //   // return {x: 5, y: 3, z: 3}
  // }

  private removeZeroValues(topRecords: Array<SohoChartData>): Array<SohoChartData> {
    const nonZeroRecords: Array<SohoChartData> = [];

    topRecords.map((item) => {
      if (item.value as number > 0) {
        nonZeroRecords.push(item);
      }
    });

    return nonZeroRecords;
  }

  private buildChartRowTitles(dataViewSet: LMDataViewSet) {
    if (!dataViewSet || (dataViewSet.data && dataViewSet.data.length <= 0)) {
      return [];
    }

    const fields = this.listSpec.busListSpec.charts[this._chartName].fields;
    const rowTitleArray = new Array(fields.length);

    if (this.selectedTotal
      && this.selectedTotal !== 'COLUMNAR_All') {
      const dspField: LMListDisplayField = this.listSpec.busListSpec.displayFields.find(x => x.fieldId === this.selectedTotal);
      rowTitleArray[0] = this.lmFormatUtilService.formatMessageRule(dspField.label, this.dataViewSet.header);
      return rowTitleArray;
    }

    for (let i = 0, length = fields.length; i < length; i++) {
      const rowTitle = this.lmFormatUtilService.formatMessageRule(fields[i].label, dataViewSet.data[0]);
      rowTitleArray[i] = rowTitle;
    }
    return rowTitleArray;
  }

  private getTopValueRecords(records: SohoChartDataArray): SohoChartDataArray {
    const sortedRecords = records.slice(0);
    sortedRecords.sort(function(a: SohoChartData, b: SohoChartData) {
      return +b.value - +a.value;
    });

    return sortedRecords;
  }

  private getFieldValue(field, dataviewField) {
    if (field && field.isPercentField) {
      return dataviewField.value * 100;
    } else {
      return parseInt(dataviewField.value, 10);
    }
  }

  private buildChartCategories(dataViewSet: LMDataViewSet, chartName: string, specFields) {
    if (!dataViewSet) {
      return [];
    }

    if (this.listSpec.busListSpec.implementsCubeView) {
      return this._buildCubeChartElementLabels(dataViewSet);
    }

    const labelArray = new Array(dataViewSet.data.length);
    let uniqueIndex = 2;
    const labelMessageRule = this.listSpec.busListSpec.charts[chartName].elementLabel;

    if (this.lmListSpecUtilService.isColumnarView(this.listSpec)) {
      return this._buildColumnarChartElementLabels(dataViewSet);
    }

    if (labelMessageRule) {
      for (let i = 0, length = dataViewSet.data.length; i < length; i++) {

        let text = this.lmFormatUtilService.formatMessageRule(labelMessageRule, dataViewSet.data[i], specFields);

        // if a value is not found use the index to display some value. This is what Canvas and 3.5 do
        if (text === '') {
          text = i.toString();
        }

        // if the same display value is found make it unique by adding a counter. Canvas and 3.5 do this alsp
        if (labelArray.includes(text)) {
          text += '(' + (uniqueIndex++) + ')';
        }
        labelArray[i] = text;
      }
    }

    return labelArray;
  }

  private _buildCubeChartElementLabels(dataViewSet: LMDataViewSet): Array<string> {
    const labelArray = new Array<string>(dataViewSet.data.length);
    let uniqueIndex = 2;
    for (let i = 0; i < dataViewSet.data.length; i++) {
      let label = dataViewSet.data[i].representativeText;
      if (!label) {
        label = dataViewSet.data[i].cubeInfo.chartLabel;
      }
      if (labelArray.indexOf(label) > -1) {
        label += '(' + (uniqueIndex++) + ')';
      }
      labelArray[i] = label;
    }
    return labelArray;
  }

  private _buildColumnarChartElementLabels(dataViewSet: LMDataViewSet): Array<string> {
    const labelArray = new Array<string>(dataViewSet.data.length);
    for (let i = 0; i < dataViewSet.data.length; i++) {
      let label: string = dataViewSet.data[i].subtotalLabel;
      let formattedLabel: string;

      if (label && label !== 'Other') {
        let dispField: LMListDisplayField;
        if (this.selectedDimension) {
          dispField = this.listSpec.busListSpec.displayFields.find(x => x.fieldId === this.selectedDimension);
        } else {
          dispField = this.listSpec.busListSpec.displayFields.find(x => x.fieldId === this.dataViewSet.columnarInfo.defaultDimension);
        }

        const value = dataViewSet.data[i].fields[label].value;
        this.lmFormatterService.listSpec = this.listSpec;
        formattedLabel = this.lmFormatterService.getDisplayText(dispField, value, dataViewSet.data[i], dataViewSet);
      } else {
        formattedLabel = this.lmFormatUtilService.formatMessage(Soho.Locale.translate('OtherLabel'), null);
      }

      let uniqueIndex = 0;
      for (let j = 0; j < labelArray.length; j++) {
        if (labelArray[j] === label) {
          uniqueIndex++;
        }
      }
      if (uniqueIndex > 0) {
        label += '(' + (uniqueIndex + 1) + ')';
      }

      labelArray[i] = formattedLabel;
    }
    return labelArray;
  }

  private getDVindex() {
    let index = this.dataViewSet && this.dataViewSet.data && this.dataViewSet.data.length > 0 ? 0 : -1;
    this.lmChartComponent = this.lmChartComponents.toArray()[0];
    if (this.lmChartComponent && this.lmChartComponent.getSelected) {
      const chartSelected = this.lmChartComponent.getSelected();
      if (chartSelected.length > 0) {
        if (chartSelected[0].groupItems) {
          index = chartSelected[0].groupItems[0].data.ref;
        } else {
          index = chartSelected[0].data.ref ? chartSelected[0].data.ref : chartSelected[0]?.elem[0]?.current?.data?.ref;
        }
      }
    } else {
      index = -1;
    }

    return index;
  }

  private postLoadChart(listPagingResponse: LMListPagingResponse) {
    if (this.getType() === 'aggregation') {
      return;
    }
    let chartDataViewSet = listPagingResponse.dataViewSet;
    const isCubeDashboardContent = this.lmListSpecUtilService.isCubeView(this.listSpec)
            && this.lmListSpecUtilService.isDashBoardContent(this.listSpec);
    if (isCubeDashboardContent
      && this.getChart().orientation === 'column'
      && chartDataViewSet.data.length > 0) {
      const chartDataViewSetClone = JSON.parse(JSON.stringify(chartDataViewSet));
      const chartDataViewSelected = chartDataViewSetClone.data[0];
      chartDataViewSetClone.data = [];
      chartDataViewSetClone.data[0] = chartDataViewSelected;
      chartDataViewSet = chartDataViewSetClone;
    }
    this.buildChartData(chartDataViewSet, this.listSpec);
    this.basicData = this._basicData;

    if (chartDataViewSet.data.length === 0 && !this.isManualLoading()) {
      this.setNoDataMessage(this.listState.filterCriteria && this.listState.filterCriteria.length > 0);
    }

    if (this.lmListSpecUtilService.isCubeView(this.listSpec)) {
      if (isCubeDashboardContent) {
        this.lmListEventService.cubeDataLoadedEvent(listPagingResponse);
      }
      return;
    }
    // setTimeout(() =>
    this.lmListEventService.dataLoadedEvent(listPagingResponse);
    // );
  }

  public addDataView(inlineCreateDataVie: LMDataView, row: number) {
    // not implemented
  }

  public removeDataView(row: number) {
    // not implemented
  }

  private getChart() {
    return this.listSpec.busListSpec.charts[this._chartName];
  }

  public cubeUpdateChart(dataViewSet: LMDataViewSet | LMDataView) {
    this.dataViewSet = dataViewSet as LMDataViewSet;
    this.buildChartData(this.dataViewSet, this.listSpec);
    this.basicData = this._basicData;
  }

  hasFilterList: boolean;
  implementsDragAndDrop: boolean;
  showFilter: boolean;
  sortOrder: LMListSortOrder;

  protected filterListCriteriaChanged(): void {
  }

}
